import { taskProgress } from "../helpers/task_progress";

interface PlaceTask {
  campaigns: Campaign[];
  distance: number;
  id: string;
  place_address: string;
  place_coordinates: object;
  place_id: number;
  place_name: string;
  place_kind: string;
  place_zip_code: string;
  success_task_count: number;
  task_count: number;
  requests: Request[];
  with_late_task: boolean;
  with_scheduled_date: boolean;
}

interface Campaign {
  id: number;
  end_date: string;
  name: string;
  status: string;
  due_date: string;
  scheduled_date: string;
  start_date: string;
  submitted_date: string | null;
}

interface Request {
  task_id: number;
  type: string;
  status: string;
  due_date: string;
  scheduled_date: string;
}

function borderColor(item: PlaceTask, campaignFilterIds: number[], campaignStatus: string[]) {
  const { completed, scheduled, late, total } = taskProgress(
    item,
    campaignFilterIds,
    campaignStatus,
  );
  if (total === completed) {
    return "border-l-emerald-300";
  } else if (late > 0) {
    return "border-l-red-300";
  } else if (scheduled > 0) {
    return "border-l-amber-300";
  } else {
    return "border-l-slate-200";
  }
}

function campaignDates(campaign: Campaign) {
  if (campaign.start_date && campaign.due_date) {
    return `du <strong>${formatShortDate(campaign.start_date)}</strong> au <strong>${formatShortDate(campaign.due_date)}</strong>`;
  }

  if (campaign.start_date) {
    return `dès le <strong>${formatShortDate(campaign.start_date)}</strong>`;
  }

  if (campaign.due_date) {
    return `avant le <strong>${formatShortDate(campaign.due_date)}</strong>`;
  }

  return "";
}

function scheduledDate(campaign: Campaign) {
  if (campaign.scheduled_date) {
    const label = campaign.status === "postponed" ? "reportée le" : "programmée le";
    return `${label} <strong>${formatShortDate(campaign.scheduled_date)}</strong>`;
  }

  return "";
}

function submittedDate(campaign: Campaign) {
  if (campaign.submitted_date) {
    return `réalisée le <strong>${formatShortDate(campaign.submitted_date)}</strong>`;
  }
  return "";
}

function pieChartGradientStyle(
  item: PlaceTask,
  campaignFilterIds: number[],
  campaignStatus: string[],
) {
  const { completed, total } = taskProgress(item, campaignFilterIds, campaignStatus);
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

  return `background: conic-gradient(#6EE7B7 ${percentage}%, transparent ${percentage}%);`;
}

function completedTaskCounter(
  item: PlaceTask,
  campaignFilterIds: number[],
  campaignStatus: string[],
) {
  const { completed, total } = taskProgress(item, campaignFilterIds, campaignStatus);
  return `${completed}/${total}`;
}

function formatShortDate(stringDate: string) {
  const date = new Date(stringDate);
  const day = date.getDate() >= 10 ? `${date.getDate()}` : `0${date.getDate()}`;
  const month = date.getMonth() + 1 >= 10 ? `${date.getMonth() + 1}` : `0${date.getMonth() + 1}`;
  return `${day}/${month}`;
}

function alpineData() {
  return {
    borderColor,
    campaignDates,
    scheduledDate,
    submittedDate,
    pieChartGradientStyle,
    completedTaskCounter,
  };
}

export default alpineData;
